import React, { useEffect, useState } from "react";
import moment from "moment";
import { IdleTimeOutModal } from "./IdleTimeOutModal";
import { useHistory } from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react";

const IdleTimeOutHandler = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [isLogout, setLogout] = useState(false);
  const { authState, oktaAuth } = useOktaAuth();
  const [isActive, setIsActive] = useState(false);

  const history = useHistory();
  let timer = undefined;
  const events = ["click", "load", "keydown"];
  const eventHandler = (eventType) => {
    if (!isLogout) {
      localStorage.setItem("lastInteractionTime", moment());
      if (timer) {
        props.onActive();
        startTimer();
      }
    }
  };

  useEffect(() => {
    addEvents();

    return () => {
      removeEvents();
      clearTimeout(timer);
    };
  }, []);

  const startTimer = () => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(
      () => {
        let lastInteractionTime = localStorage.getItem("lastInteractionTime");
        const diff = moment.duration(
          moment().diff(moment(lastInteractionTime))
        );
        let timeOutInterval = props.timeOutInterval
          ? props.timeOutInterval
          : 900000;
        if (isLogout) {
          clearTimeout(timer);
        } else {
          if (diff._milliseconds < timeOutInterval) {
            startTimer();
            props.onActive();
          } else {
            props.onIdle();
            setShowModal(true);
            const cTime = timer;

            setTimeout(() => {
              if (!isLogout && cTime == timer) {
                handleLogout();
              }
            }, 60000);
          }
        }
      },
      props.timeOutInterval ? props.timeOutInterval : 900000
    );
  };
  const addEvents = () => {
    events.forEach((eventName) => {
      window.addEventListener(eventName, eventHandler);
    });

    startTimer();
  };

  const removeEvents = () => {
    events.forEach((eventName) => {
      window.removeEventListener(eventName, eventHandler);
    });
  };

  const handleContinueSession = () => {
    setShowModal(false);
    setLogout(false);
  };
  const handleLogout = () => {
    removeEvents();
    clearTimeout(timer);
    setLogout(true);
    localStorage.setItem("loggedIn", "false");
    localStorage.removeItem("loginAs")
    localStorage.removeItem('loginAsFlag')
    localStorage.removeItem('loginAsEmail')
    oktaAuth.signOut();
    setShowModal(false);
  };

  return (
    <IdleTimeOutModal
      showModal={showModal}
      handleContinue={handleContinueSession}
      handleLogout={handleLogout}
    />
  );
};

export default IdleTimeOutHandler;
